import { createAsyncThunk } from "@reduxjs/toolkit";
import LandingPageAPI, { LandingPageApiUrls } from "../API/LandingPageAPI";

import LocalStorage from "../../../Services/Storage/LocalStorage";
import StorageModel from "../../../Models/StorageModel";
import HttpsClient from "../../../Services/HttpsClient";
import ApiHelper from "../../../Services/ApiHelper";
import Cache from "../../../Services/Cache";

const storage = new LocalStorage();
const storageModel = new StorageModel(storage);
const cache = new Cache(storageModel);

const httpsClient = new HttpsClient();
const apiHelper = new ApiHelper(httpsClient);
const landingPageAPI = new LandingPageAPI(apiHelper, cache);

export const createConnectionRequest = createAsyncThunk(
  LandingPageApiUrls.createConnectionRequest,
  async (payload, { getState, dispatch }) => {
    const state = getState();
    const token = state.auth.user.token;
    const response = await landingPageAPI.createConnectionRequest(payload, token);

    return response;
  }
);
export const getVitrineAssesses = createAsyncThunk(
  LandingPageApiUrls.getVitrineAssesses,
  async (payload, { getState, dispatch }) => {
    const state = getState();
    const token = state.auth.user.token;
    const response = await landingPageAPI.getVitrineAssesses(payload, token);

    return response;
  }
);
